import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-资产入库电子流",
  "use": "icon-资产入库电子流-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-资产入库电子流\"><path d=\"M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z\" fill=\"#1296db\" /><path d=\"M775.616 489.408l-86.592-227.712H595.712v17.536h71.232l58.432 208H599.808L510.656 568.96l-94.72-81.792h-124.16l58.368-208h72.64v-17.536H330.816L245.76 492.608h0.448a10.304 10.304 0 0 0-0.448 2.752v233.728c0 4.544 3.712 8.192 8.256 8.192h516.032a8.32 8.32 0 0 0 8.256-8.192V495.36a8.32 8.32 0 0 0-2.688-5.952zM510.72 450.944l91.584-105.536h-48.192V231.168H469.824v114.304h-48.128L510.72 450.944zM554.112 204.8H469.824v14.656h84.288V204.8z\" fill=\"#FFFFFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/资产入库电子流.svg
// module id = N6IV
// module chunks = 183